<spinner *ngIf="isLoading"></spinner>
<div class="policy-links" *ngIf="!isLoading && (topLinks.length || bottomLinks.length)">
  <div class="policy-links__head">
    <h3 class="policy-links__title">{{ title }}</h3>
  </div>
  <ng-container *ngFor="let link of topLinks">
    <div class="policy-links__row policy-links__row--top">
      <a
        *ngIf="link.linkHref && !link.modalName && !link.actionItem"
        class="text-link text-link--underline"
        target="_blank"
        href="{{ link.linkHref }}"
      >
        {{ link.displayText }}
      </a>

      <a *ngIf="link.modalName" class="text-link text-link--underline" (click)="openModal(link.modalName)">
        {{ link.displayText }}
      </a>
    </div>
  </ng-container>
  <ng-container *ngFor="let link of bottomLinks">
    <div class="policy-links__row policy-links__row--bottom">
      <a
        *ngIf="link.linkHref && !link.modalName"
        class="text-link--cancel text-link--underline"
        target="_blank"
        href="{{ link.linkHref }}"
      >
        {{ link.displayText }}
      </a>

      <a *ngIf="link.modalName" class="text-link--cancel text-link--underline" (click)="openModal(link.modalName)">
        {{ link.displayText }}
      </a>
    </div>
  </ng-container>
</div>
